/**
 * 自提图标
 */
const PickIcon = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M6.25 3.75H13.75L16.25 7.5V16.25H3.75V7.5L6.25 3.75Z"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path d="M3.75 7.5H16.25" stroke="black" strokeWidth="1.25" />
      <path d="M8.125 10.625H11.875" stroke="black" strokeWidth="1.25" />
      <path d="M10 3.75L10 7.5" stroke="black" strokeWidth="1.25" />
    </svg>
  )
}

export default PickIcon
